
import Vue from 'vue'
import { SignOutEverywhereFailed } from './signout'
import { UserMenuItem, userMenu } from './usermenu'

export default Vue.extend({
  name: 'App',

  data: () => ({
    pageTitle: 'Metalist',
    drawer: null,
    items: [
      { title: 'Listas', icon: 'mdi-format-list-checks', to: '/' },
      { title: 'Acerca de', icon: 'mdi-help-box', to: '/about' }
    ],
    failure: ''
  }),

  // The menu is a computed rather than state because it is decided entirely by
  // the store: recomputing it on every render is what makes it appear when
  // somebody signs in and disappear when they sign out, without this component
  // being told either happened.
  computed: {
    menu () {
      return userMenu()
    },

    // The button reads as the account when there is one and as the way to get
    // one when there is not, so the control does not say "Sign in" to somebody
    // who is already signed in.
    menuLabel () {
      return this.menu.username || 'Sign in'
    }
  },

  methods: {
    async run (item: UserMenuItem) {
      // An entry with an `action` rather than a `to`. Nothing to do for the other
      // kind: `v-list-item` navigates them itself.
      if (item.action === undefined) {
        return
      }

      this.failure = ''

      try {
        await item.action()
      } catch (error) {
        // A sign-out everywhere that failed leaves the session in place -- see
        // `signout.ts` -- so the user is still signed in and needs to be told why
        // nothing happened. Anything else here would be a bug reaching the
        // screen, and it is reported rather than swallowed for the same reason.
        this.failure = error instanceof SignOutEverywhereFailed
          ? error.message
          : 'Something went wrong. Please try again.'
      }
    }
  }
})
